import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import { CartContext } from "../../contexts/CartContext";
import Modal from "./product-detail-modal";
import { AuthContext } from "../../contexts/AuthContext";

export interface Product {
  id: string;
  name: string;
  image: any;
  hoverImage: string;
  code: string;
  category: string;
  isSample: boolean;
}

export const ProductCard: React.FC<Product> = ({
  id,
  name,
  image,
  code,
  category,
  isSample,
}) => {
  const [modalShow, setModalShow] = React.useState(false);
  const { handleAddToCart, cartItems } = useContext(CartContext);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  let imageURI = "";
  if (image && image.key) {
    imageURI = `https://d1gdand68muq63.cloudfront.net/products/sm/${image.key}`;
    if (isSample) {
      imageURI = `https://d1gdand68muq63.cloudfront.net/sample-products/sm/${image.key}`;
    }
  }
  const productInCart = cartItems.find((item) => item.productId === id);

  return (
    <div className="ec-product-inner">
      <div className="ec-pro-image-outer">
        <div className="ec-pro-image">
          <a className="image">
            {imageURI ? (
              <>
                <img
                  className="main-image"
                  style={{
                    height: "300px",
                    objectFit: "cover",
                    objectPosition: "center",
                    width: "100%",
                  }}
                  src={imageURI}
                  alt="Product"
                />
                <img
                  className="hover-image"
                  style={{
                    height: "300px",
                    objectFit: "cover",
                    objectPosition: "center",
                    width: "100%",
                  }}
                  src={imageURI}
                  alt="Product"
                />
              </>
            ) : (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                  width: "100%",
                }}
              >
                No Image Available
              </div>
            )}
          </a>
          {category && (
            <span className="flags">
              <span className={category.toLowerCase().replace(" ", "-")}>
                {category}
              </span>
            </span>
          )}
          <div className="ec-pro-actions">
            {user.userType === "Buyer" && (
              <button
                onClick={() => {
                  if (productInCart) {
                    navigate("/cart");
                  } else {
                    handleAddToCart({ productId: id, quantity: 1 });
                  }
                }}
                title={productInCart ? "View Cart" : "Add to Cart"}
                className="add-to-cart"
              >
                {productInCart ? (
                  "View Cart"
                ) : (
                  <img
                    src="assets/images/icons/cart.svg"
                    className="svg_img pro_svg"
                    alt=""
                  />
                )}
              </button>
            )}

            <button
              style={{ cursor: "pointer" }}
              className="ec-btn-group quickview"
              data-link-action="quickview"
              title="Quick view"
              onClick={() => {
                setModalShow(true);
              }}
            >
              <img
                src="assets/images/icons/quickview.svg"
                className="svg_img pro_svg"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <div className="ec-pro-content">
        <h5 className="ec-pro-title">
          <Link
            style={{ cursor: "pointer" }}
            to={`/product/${id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {name}
          </Link>
        </h5>
        <span className="ec-price">
          {/* <span className="old-price">{oldPrice}</span> */}
          <span className="new-price">{code}</span>
        </span>
      </div>
      {modalShow && (
        <Modal
          id={id}
          isOpen={modalShow}
          onClose={() => {
            setModalShow(false);
          }}
        />
      )}
    </div>
  );
};
